import { useEffect, useState } from "react";
import { usePrefersReducedMotion } from "../lib/hooks";
import { useTheme } from "../lib/theme";

/** CRT/VFD treatment for the dark "dash" theme only: scanlines, rolling
 *  tracking bar, animated grain, vignette, and a small instrument HUD (REC ● /
 *  SP / live timestamp). Nothing renders in light mode (warm paper stays
 *  clean). Reduced-motion drops the animated layers (CSS) + freezes the clock. */
export function VhsOverlay() {
  const reduce = usePrefersReducedMotion();
  const { theme } = useTheme();
  const [now, setNow] = useState(() => new Date());

  useEffect(() => {
    if (reduce || theme === "light") return;
    const t = setInterval(() => setNow(new Date()), 1000);
    return () => clearInterval(t);
  }, [reduce, theme]);

  if (theme === "light") return null;

  const stamp = now
    .toLocaleString("en-US", {
      month: "short",
      day: "2-digit",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
      hour12: true,
    })
    .toUpperCase();

  return (
    <>
      <div className="vhs-grain" aria-hidden />
      <div className="tracking-bar" aria-hidden />
      <div className="scanlines" aria-hidden />
      <div className="crt-vignette" aria-hidden />

      {/* Instrument HUD */}
      <div
        aria-hidden
        className="pointer-events-none fixed right-3 top-3 z-[9999] flex items-center gap-2 font-body text-[15px] uppercase tracking-widest"
        style={{ textShadow: "0 0 6px rgba(255,174,61,.5)" }}
      >
        <span className="h-2.5 w-2.5 animate-pulse rounded-full bg-red shadow-glow" />
        <span className="text-red">rec</span>
        <span className="text-amber">sp</span>
      </div>
      {/* Bottom-RIGHT, like a VCR date stamp: bottom-left sits on the sidebar's theme
          toggle and is wider than the sidebar, so it straddled into the page. */}
      <div
        aria-hidden
        className="pointer-events-none fixed bottom-3 right-3 z-[9999] font-body text-[15px] uppercase tracking-widest text-green"
        style={{ textShadow: "0 0 6px rgba(92,240,138,.5)" }}
      >
        ▶ play &nbsp; {stamp}
      </div>
    </>
  );
}
